import { OptionListDataInt } from "../types/p-l-e-calculator-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, request } from "../core/api.client";

export const getPleCalculatorDetails = async (): Promise<IResponse<OptionListDataInt[]>> => {
  const cityDetails = await request<OptionListDataInt[]>({
    method: "GET",
    url: API_PATHS.pleMaster,
  });
  return cityDetails;
};
